var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 1.33301C5.41992 1.33301 3.33325 3.41967 3.33325 5.99967C3.33325 9.49967 7.99992 14.6663 7.99992 14.6663C7.99992 14.6663 12.6666 9.49967 12.6666 5.99967C12.6666 3.41967 10.5799 1.33301 7.99992 1.33301ZM7.99992 7.66634C7.07992 7.66634 6.33325 6.91967 6.33325 5.99967C6.33325 5.07967 7.07992 4.33301 7.99992 4.33301C8.91992 4.33301 9.66658 5.07967 9.66658 5.99967C9.66658 6.91967 8.91992 7.66634 7.99992 7.66634Z",
    fill: "#E5E5DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFill);
export default __webpack_public_path__ + "static/media/location_fill.46dea025fc575278be8255a23c3f3efd.svg";
export { ForwardRef as ReactComponent };